import { motion } from "framer-motion";
import { ShieldCheck, Check } from "lucide-react";
import { useT } from "@/i18n_extra3";

export const WarrantySeal = () => {
  const t = useT();
  const w = t.warranty;
  return (
    <section className="py-24 sm:py-28 bg-[#FAF9F6]" data-testid="warranty-section">
      <div className="max-w-5xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="relative border-2 border-[#D4AF37]/60 rounded-3xl px-8 sm:px-14 py-14 text-center bg-white/60 overflow-hidden"
        >
          <div className="absolute -top-10 -right-10 w-40 h-40 rounded-full bg-[#D4AF37]/10" />
          <div className="absolute -bottom-12 -left-12 w-48 h-48 rounded-full bg-[#D4AF37]/10" />
          <div className="relative">
            <div className="mx-auto w-20 h-20 rounded-full bg-[#D4AF37] flex items-center justify-center shadow-xl">
              <ShieldCheck className="w-10 h-10 text-black" />
            </div>
            <span className="block mt-8 text-xs font-bold tracking-[0.25em] uppercase text-[#B8860B]">{w.label}</span>
            <h2 className="mt-4 font-display font-bold tracking-tight text-4xl sm:text-5xl text-[#111111]">{w.title}</h2>
            <p className="mt-4 text-black/60 text-base sm:text-lg max-w-xl mx-auto">{w.sub}</p>
            <div className="mt-10 flex flex-wrap justify-center gap-x-10 gap-y-4">
              {w.points.map((p) => (
                <div key={p} className="flex items-center gap-2.5 font-semibold text-sm sm:text-base text-black/75">
                  <span className="w-6 h-6 rounded-full bg-[#D4AF37] text-black flex items-center justify-center shrink-0">
                    <Check className="w-3.5 h-3.5" />
                  </span>
                  {p}
                </div>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
